import http from '../../../common/utils/http'
import apiUtils from '../../../common/utils/apiUtils'
import {API_BASE_URL} from '../../../common/utils/commonUrl'

export default {
  getConsumedCoupon: () => {
    return http.get(`${API_BASE_URL}/api/wxoa/coupon/couponExample/getUserVerifySalesDTOList`).then(
      function (result) {
        return apiUtils.getDataFormResponse(result)
      },
      function (error) {
        console.log('error', error)
      }
    )
  }
}



// WEBPACK FOOTER //
// ./src/api/wx-member/member-consuming-records/member-consuming-records.js